import { useCallback } from 'react';

import { useNavigationReset } from '../useNavigationReset';

/**
 * Returns a callback that resets the navigation stacks back to the account
 * menu so the previous user's screens are no longer presented after sign-out.
 */
export const useResetStacksPostLogout = () => {
  const resetNavigation = useNavigationReset();

  return useCallback(() => {
    resetNavigation({
      index: 0,
      routes: [
        {
          name: '(tabs)',
          state: {
            routes: [{ name: 'account', state: { routes: [{ name: 'menu/index' }] } }],
          },
        },
      ],
    });
  }, [resetNavigation]);
};
